import React from 'react'
import { Tag } from '@surecompanies/core_components'
import { TaskStatus, PartnerSyncStatus } from '../types'

interface StatusTagProps {
  status: TaskStatus | PartnerSyncStatus | string
  className?: string
}

const getStatusColor = (
  status: string
): 'success' | 'processing' | 'error' | 'default' => {
  switch (status.toLowerCase()) {
    case 'completed':
      return 'success'
    case 'submitted':
    case 'processing':
      return 'processing'
    case 'failed':
    case 'cancelled':
      return 'error'
    default:
      return 'default'
  }
}

const formatStatus = (status: string): string => {
  return status.charAt(0).toUpperCase() + status.slice(1)
}

export const StatusTag: React.FC<StatusTagProps> = ({ status, className }) => {
  if (!status) return null

  return (
    <Tag color={getStatusColor(status)} className={className}>
      {formatStatus(status)}
    </Tag>
  )
}
